// extracted by mini-css-extract-plugin
export default {"radio":"ModernRadioButtonGroup_radio__dD8Sc"};